import { render, staticRenderFns } from "./i-profile.vue?vue&type=template&id=0087a9dd&scoped=true&"
import script from "./i-profile.vue?vue&type=script&lang=js&"
export * from "./i-profile.vue?vue&type=script&lang=js&"
import style0 from "./i-profile.vue?vue&type=style&index=0&id=0087a9dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0087a9dd",
  null
  
)

export default component.exports